import React from "react"
import * as Constants from '../../utils/constants'
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem
} from 'design-react-kit';
import { isPresentAuthenticatedUser } from "../../utils/utilities";

export const SibaBreadcrumb = (props) => {

  return ( 
    <div>
      {!isPresentAuthenticatedUser() ? (
      <Container className="px-2 my-2" id="briciole" tag="section">
        <Row tag="div" >
          <Col className="px-2" tag="div">
            <nav aria-label="breadcrumb" className="breadcrumb-container">
              <Breadcrumb aria-label="breadcrumb" listTag="ol" tag="nav">
                <BreadcrumbItem tag="li">
                  <a href="https://servizi.regione.liguria.it/page/welcome/BOLLO_AUTO"> Pagina Iniziale</a>
                  <span className="separator"> / </span>
                </BreadcrumbItem>
                <BreadcrumbItem tag="li">
                  <a href={Constants.URL_TASSAAUTO}> Home </a>
                </BreadcrumbItem>
                {props.pageName ?
                  (<BreadcrumbItem active aria-current="page" tag="li" >
                    <span className="separator"> / </span>
                    {props.pageName}
                  </BreadcrumbItem>)
                  :
                  (null)}
              </Breadcrumb>
            </nav>
          </Col>
        </Row>
      </Container>) :
                  (<Container className="px-2 my-2" id="briciole" tag="section">
                  <Row tag="div" >
                    <Col className="px-2" tag="div">
                      <nav aria-label="breadcrumb" className="breadcrumb-container">
                        <Breadcrumb aria-label="breadcrumb" listTag="ol" tag="nav">
                          <BreadcrumbItem tag="li">
                           <a href="https://servizi.regione.liguria.it/page/welcome/BOLLO_AUTO"> Pagina Iniziale</a>
                           <span className="separator"> / </span>
                          </BreadcrumbItem>
                          <BreadcrumbItem tag="li">
                            <a href={Constants.APP_BASE_NAME + Constants.URL_SERVIZI_ONLINE_PROTECTED}> Home </a>
                          </BreadcrumbItem>
                          {props.pageName ?
                            (<BreadcrumbItem active aria-current="page" tag="li" >
                              <span className="separator"> / </span>
                              {props.pageName}
                            </BreadcrumbItem>)
                            :
                            (null)}
                        </Breadcrumb>
                      </nav>
                    </Col>
                  </Row>
                </Container>)}
    </div>                      
  );
};

export default SibaBreadcrumb;